module.exports = __webpack_public_path__ + "fa-brands-400.f319eac1c755f9929fd8";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/webfonts/fa-brands-400.woff2
// module id = ../../../../../src/scss/webfonts/fa-brands-400.woff2
// module chunks = styles